import { API_ENDPOINTS, api } from "../apis/constants";
import { cacheService } from "./cache.service";

export interface Banner {
    id: string;
    name: string;
    description?: string;
    image: string;
    link: string;
    status: string;
    index: number;
    createdAt: string;
    updatedAt: string;
}

interface GetBannersOptions {
    forceFresh?: boolean;
    cacheTTL?: number;
}

class BannerService {
    private CACHE_KEY = 'banners_data';

    async getActiveBanners(options: GetBannersOptions = {}): Promise<Banner[]> {
        return cacheService.get<Banner[]>(
            this.CACHE_KEY,
            async () => {
                try {
                    const response = await api.get<Banner[]>(API_ENDPOINTS.BANNERS.ACTIVE);
                    return response.data;
                } catch (error) {
                    console.error('Error fetching banners:', error);
                    throw error;
                }
            },
            {
                forceFresh: options.forceFresh,
                ttl: options.cacheTTL || 300 // Cache for 5 minutes by default
            }
        );
    }
}

export const bannerService = new BannerService(); 